import {
  ChartEmptyState,
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '8px',
  textAlign: 'center',
  alignItems: 'center',
  padding: '32px',
  justifyContent: 'center'
}

const ScreenshotsEmptyState = () =>
  <div style={wrapperStyle}>
    <Header
      hasNoTopMargin
      rank={4}
    >
      No screenshots found
    </Header>
    <Paragraph>
      <Color variant='theme-description-text'>
        Screenshots are captured automatically in test runs if there are any failures detected. To enable screenshots, please add the relevant scripts to the suite.
      </Color>
    </Paragraph>
  </div>

export default ScreenshotsEmptyState
